export default {
	state: {
		loading: false,
		errorMsg: '',
		schoolName: window.localStorage.schoolName || '',
		yx: '',
		zy: '',
		bj: '',
		isK12: false,
		sfzsJfnd: 'NO', // 是否展示缴费年度
		xqList: [], // 校区列表
		yxList: [], // 院系列表
		zyList: [], // 专业列表
		bjList: [], // 班级列表
	},
	mutations: {
		requestLoading(state, loading) {
			state.loading = loading;
		},
		requestErrorMsg(state, error) {
			state.errorMsg = error;
		},
		setSchoolName(state, schoolName) {
			state.schoolName = schoolName;
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.schoolName = state.schoolName;
			}
		},
		getIsK12(state, data) {
			sessionStorage.setItem('isK12', data);
			state.isK12 = data;
		},
		getYx(state, data) {
			state.yx = data;
		},
		getZy(state, data) {
			state.zy = data;
		},
		getBj(state, data) {
			state.bj = data;
		},
		getSfZsJfnd(state, data) {
			sessionStorage.setItem('sfzsJfnd', data);
			state.sfzsJfnd = data;
		},
		getXqList(state, data) {
			state.xqList = data;
		},
		getYxList(state, data) {
			state.yxList = data;
		},
		getZyList(state, data) {
			state.zyList = data;
		},
		getBjList(state, data) {
			state.bjList = data;
		},
	},
	actions: {
		async getDicAction({ commit }, params) {
			const k12opt = sessionStorage.getItem('k12opt');
			if (sessionStorage.getItem('k12opt')) {
				const res = JSON.parse(k12opt);
				if (params.type === 'isK12') {
					commit('getIsK12', res.isK12);
				} else if (params.type === 'yx') {
					commit('getYx', res.yx);
				} else if (params.type === 'zy') {
					commit('getZy', res.zy);
				} else if (params.type === 'bj') {
					commit('getBj', res.bj);
				} else if (params.type === 'sfzsJfnd') {
					commit('getSfZsJfnd', res.sfzsJfnd);
				} 
				return res;
			}
			const res = await a.api('commonRequest', {
				url: '/upms-sys/sysparam/getByParamCode',
				param_code: params.param_code,
			});
			const sessionK12 = sessionStorage.getItem('k12opt');
			let jsonK12 = JSON.parse(sessionK12 || '{}');
			if (params.type === 'isK12') {
				commit('getIsK12', res.result);
			} else if (params.type === 'yx') {
				commit('getYx', res.result);
			} else if (params.type === 'zy') {
				commit('getZy', res.result);
			} else if (params.type === 'bj') {
				commit('getBj', res.result);
			} else if (params.type === 'sfzsJfnd') {
				commit('getSfZsJfnd', res.result);
			}
			jsonK12 = Object.assign(jsonK12, {
				[params.type]: res.result,
			});
			sessionStorage.setItem('k12opt', JSON.stringify(jsonK12));
			return res;
		},
		setLoading({ commit }, loading) {
			commit('requestLoading', loading);
		},
		setErrorMsg({ commit }, error) {
			commit('requestErrorMsg', error);
			setTimeout(() => {
				commit('requestErrorMsg', '');
			});
		},
		setSchoolName({ commit }, schoolName) {
			commit('setSchoolName', schoolName);
		},
		/** 
		 * 获取学校的校区、院系、专业、班级列表
		 * @params api 传入需要获取的列表类型。默认全部获取
		 * @params apiParam  对应api的参数对象。举例：{ 'xq':{ page_num: 1 }, 'yx': '' }
		*/
		async getXqYxZyBjLists({ commit }, apis = ['xq', 'yx', 'zy', 'bj'], apiParam = {}) {
			if (apis.includes('xq')) {
				// 获取校区列表，并存入store中
				const param = apiParam['xq'] || { page_num: 1, page_size: 999999, zt: 'ENABLE' };
				const xqListRes = await a.api('findXqLIst', param);
				const xqList = xqListRes.result.list.map((value) => ({
					...value,
					value: value.dm, 
					label: value.mc 
				}));
				commit('getXqList', xqList);
				sessionStorage.setItem('xqList', JSON.stringify(xqList));
			} 
			if (apis.includes('yx')) {
				// 获取院系列表，并存入store中
				const param = apiParam['yx'] || '';
				const yxListRes = await a.api('yxjgYxSelect', param);
				const yxList = yxListRes.result.map(item => ({
					...item,
					label: item.node_name,
					value: item.info_dm,
				}));
				commit('getYxList', yxList);
				sessionStorage.setItem('yxList', JSON.stringify(yxList));
			}
			if (apis.includes('zy')) {
				// 获取专业列表，并存入store中
				const param = apiParam['zy'] || '';
				const zyListRes = await a.api('yxjgZySelect', param);
				const zyList = zyListRes.result.map(item => ({
					...item,
					label: item.node_name,
					value: item.info_dm,
				}));
				commit('getZyList', zyList);
				sessionStorage.setItem('zyList', JSON.stringify(zyList));
			}
			if (apis.includes('bj')) {
				// 获取班级列表，并存入store中
				const param = apiParam['bj'] || '';
				const bjListRes = await a.api('yxjgBjSelect', param);
				const bjList = bjListRes.result.map(item => ({
					...item,
					label: item.node_name,
					value: item.info_dm,
				}));
				commit('getBjList', bjList);
				sessionStorage.setItem('bjList', JSON.stringify(bjList));
			}
		}
	},
	getters: {
		xqList: ((state) => {
			const _storeList = sessionStorage.getItem('xqList') ? JSON.parse(sessionStorage.getItem('xqList')) : {};
			const _list = state.xqList.length ? state.xqList : _storeList;
			return _list;
		}),
		yxList: ((state) => {
			const _storeList = sessionStorage.getItem('yxList') ? JSON.parse(sessionStorage.getItem('yxList')) : {};
			const _list = state.yxList.length ? state.yxList : _storeList;
			return _list;
		}),
		zyList: ((state) => {
			const _storeList = sessionStorage.getItem('zyList') ? JSON.parse(sessionStorage.getItem('zyList')) : {};
			const _list = state.zyList.length ? state.zyList : _storeList;
			return _list;
		}),
		bjList: ((state) => {
			const _storeList = sessionStorage.getItem('bjList') ? JSON.parse(sessionStorage.getItem('bjList')) : {};
			const _list = state.bjList.length ? state.bjList : _storeList;
			return _list;
		}),
	},
};
